const About = () => {
	return (
		<div className="bg-slate-950 text-secondary h-full flex flex-col items-center justify-center p-10 text-center">
			<h2 className="text-3xl font-semibold">About Us</h2>
			<p className="text-lg max-w-2xl mt-4">
				ICEPyramid Communication Limited is committed to delivering premium IT
				solutions with expertise and precision.
			</p>
		</div>
	);
};

export default About;
